import environment from '../../environment';
import StoresAfterSalesControl from './StoresAfterSalesControl';

export class CompetitorsAfterSalesControl extends StoresAfterSalesControl {
    constructor() {
        const options = {
            name: 'CompetitorsAfterSales',
            context: 'CompetitorsAfterSales',
            stores: environment.get('CONFIG.COMPETITORS'),
        };

        super(options);
    }

    static getInstance() {
        if (!CompetitorsAfterSalesControl._instance) {
            CompetitorsAfterSalesControl._instance = new CompetitorsAfterSalesControl();
        }

        return CompetitorsAfterSalesControl._instance;
    }
}

export default CompetitorsAfterSalesControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/AfterSales/CompetitorsAfterSalesControl.js